import { render, staticRenderFns } from "./InternalInformation.vue?vue&type=template&id=2732e976&"
import script from "./InternalInformation.vue?vue&type=script&lang=js&"
export * from "./InternalInformation.vue?vue&type=script&lang=js&"
import style0 from "./InternalInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports